"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Grade Reports Module
__exportStar(require("./services/grade-reports"), exports);
__exportStar(require("./models/grade-reports"), exports);
// Shared Chat Components
__exportStar(require("./components/chat"), exports);
// Shared Services
__exportStar(require("./services/doubts"), exports);
__exportStar(require("./services/ai-workspace"), exports);
// Webform Renderer
__exportStar(require("./components/webform"), exports);
